import React from 'react';
import {useProspectScoreSettingQuery, ProspectScoreCustomizeItem} from 'api';
import Item from './Item';
import {CustomizeItemContext} from './CustomizeItemContext';

const List = () => {
  const {data: {prospectScoreSetting = {}} = {}} = useProspectScoreSettingQuery(
    {},
  );
  const items =
    prospectScoreSetting?.clientProspectScoreSettingCustomizeItems ?? [];

  return (
    <>
      {items?.map((item: ProspectScoreCustomizeItem) => {
        return (
          <CustomizeItemContext.Provider value={item}>
            <Item key={item.id} />
          </CustomizeItemContext.Provider>
        );
      })}
    </>
  );
};

export default List;
